import { ViewInAr } from '@mui/icons-material';
import React, { forwardRef } from 'react';

export const MatchIcon = forwardRef<SVGSVGElement, React.ComponentProps<typeof ViewInAr>>((properties, reference) => {
  return <ViewInAr ref={reference} {...properties} style={{ ...properties.style }} />;
});

MatchIcon.displayName = 'MatchIcon';
